import React, { useState } from "react";
import { Popup } from "../../../../../components/popup.js";
import {
  RenderSvg,
  baseUrl,
  handleCopy,
} from "../../../../../utils/helpers/helper";

export default function BlogInfo({
  blog_category = {},
  blogTitle,
  styles,
  PdfFile = "",
  readTime = "",
  className,
}) {
  const [openPopup, setOpenPopup] = useState(false);
  const [copied, setCopied] = useState(false);
  return (
    <>
      {copied && <div className="showCopied"> Link Copied</div>}
      <div className={`${styles?.blogSingleBannerItems} ${className}`}>
        <div className={styles?.dateAndCategory}>
          <div className={`${styles?.categoryName} mobile-hide`}>
            {blog_category?.categoryName}
          </div>
          <div className={styles?.BlogBannerTime}>
            <RenderSvg
              IconName={"clock"}
              style={{ height: "25px", width: "25px" }}
            />
            {readTime || "5 min"} read
          </div>
        </div>
        <div className={styles?.blogSingleBannerIcons}>
          <div>
            <button onClick={() => setOpenPopup(true)}>
              <span>
                <RenderSvg IconName={"share-alt"} style={{ height: "25px" }} />
              </span>
            </button>
          </div>
          {/* {PdfFile && (
            <div>
              <a
                href={baseUrl + PdfFile?.url}
                target={"_blank"}
                download={true}
              >
                <span>
                  <RenderSvg
                    IconName={"arrow-to-bottom"}
                    style={{ height: "25px" }}
                  />
                </span>
              </a>
            </div>
          )} */}

          <div>
            <button
              onClick={() =>
                handleCopy({
                  onSuccess: () => {
                    setCopied(true);
                    setTimeout(() => {
                      setCopied(false);
                    }, 1500);
                  },
                })
              }
            >
              <RenderSvg
                IconName={copied ? "check" : "link"}
                style={{ height: "25px", width: "25px" }}
              />
            </button>
          </div>
        </div>
      </div>
      <Popup openPopup={openPopup} setOpenPopup={setOpenPopup} share />
    </>
  );
}
